import delta from "../utils/delta";
import {
    addEventListener,
    DCL,
} from "../literals";
import {
    d,
    c,
    ce,
} from "../globals";

/**
 * class name should not match mocked object
 */
let mocked = true;
export default class jQueryMock {
    constructor() {
        this.known = [];
    }
    init() {

        let Mock;
        let Mock$;

        // the goal here is to capture a real jQuery object and override its load and ready methods
        // to delay firing ready() until WP-Meteor finishes loading JS
        const override = (jQuery, symbol) => {

            if (mocked && jQuery && jQuery.fn && !jQuery.__wpmeteor) {
                process.env.DEBUG && c(delta(), "new " + symbol + " detected", jQuery.__wpmeteor, jQuery);

                // can't use () => {} as it binds to different this
                const enqueue = function (func) {
                    process.env.DEBUG && c(delta(), "enqueued jQuery(func)", func);
                    // there is a loop when you call $("selector", $), as it calls $.ready
                    // which in turn calls readyList.then( fn ) and returns this
                    // without this code, page-infinite-loop.html hangs
                    if (func === jQuery) {
                        return this;
                    }
                    d[addEventListener](DCL, e => {
                        process.env.DEBUG && c(delta(), "running enqueued jQuery function", func);
                        func.call(d, jQuery, e, "jQueryMock");
                    });
                    return this;
                };

                this.known.push([jQuery, jQuery.fn.ready, jQuery.fn.init?.prototype?.ready]);
                jQuery.fn.ready = enqueue;
                if (jQuery.fn.init?.prototype?.ready) {
                    jQuery.fn.init.prototype.ready = enqueue;
                }
                jQuery.__wpmeteor = true;
            }
            return jQuery;
        };

        if (window.jQuery || window.$) {
            // not throwing error, as it might come from a chrome extension
            // but also not mocking it, just giving a warning
            process.env.DEBUG && ce(delta(), "WARNING: JQUERY WAS INSTALLED BEFORE WP-METEOR, PROBABLY FROM A CHROME EXTENSION");
        }

        Object.defineProperty(window, "jQuery", {
            get() {
                return Mock;
            },
            set(jQuery) {
                Mock = override(jQuery, "jQuery");
            },
            configurable: true,
        });

        Object.defineProperty(window, "$", {
            get() {
                return Mock$;
            },
            set($) {
                Mock$ = override($, "$");
            },
            configurable: true,
        });
    }
    unmock() {
        this.known.forEach(([jQuery, oldReady, oldPrototypeReady]) => {
            process.env.DEBUG && c(delta(), "unmocking jQuery", jQuery);
            jQuery.fn.ready = oldReady;
            if (jQuery.fn.init?.prototype?.ready && oldPrototypeReady) {
                jQuery.fn.init.prototype.ready = oldPrototypeReady;
            }
        });
        mocked = false;
    }
}
